
export default function HowItWorks({ id }: { id?: string }) {
  const steps = [
    {
      number: '01',
      title: 'We set up your facility template',
      description: 'One-time setup. We handle the design and branding.',
      time: 'Staff time: ~10 minutes once.'
    },
    {
      number: '02',
      title: 'We create the issue + manage sponsors',
      description:
        "We produce the content, design, and handle all sponsor operations. You don't sell ads.",
      time: 'We manage sponsorship selection, placements, and disclosures.'
    },
    {
      number: '03',
      title: 'You optionally add local updates',
      description: 'Share events and announcements via a simple form.',
      time: 'Staff time: ~5 minutes per issue.'
    },
    {
      number: '04',
      title: 'You review the final proof',
      description: 'Review for brand alignment and appropriateness before distribution.',
      time: 'Staff time: ~5–10 minutes per issue.'
    }
  ];

  return (
    <section id={id} className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">How it works</h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Low burden for staff. You review for brand alignment before distribution.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gray-50 rounded-lg p-6 border border-gray-100 hover:shadow-lg hover:bg-white transition-all duration-300 h-full">
                <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-red-500 mb-3">
                  {step.number}
                </div>
                <h3 className="text-base font-semibold text-gray-900 mb-2 leading-tight">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-1">
                  {step.description}
                </p>
                <p className="text-xs text-gray-500 leading-relaxed">
                  {step.time}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <p className="text-xs text-gray-500">
            Nothing is distributed without your approval of the final proof.
          </p>
        </div>
      </div>
    </section>
  );
}
